// extracted by mini-css-extract-plugin
module.exports = {"content":"textbox_content__1N3ZR"};